import { writable} from 'svelte/store';

export const place=writable(null);